// extracted by mini-css-extract-plugin
export default {"badgeContainer":"styles_badgeContainer__K3Zuv"};